<div class="absolute top-8 left-8">
  <div class="flex items-center gap-4">
    <nrc-icon
      class="w-12 h-12"
      [name]="'translate-circle'"
      [fillColor]="'cyan'"
    />
    <span class="text-4xl font-light tracking-wide">
      {{ translationModalTitle }}
    </span>
  </div>
</div>

<p class="font-light text-md text-[#ADADAD] pt-10">
  {{ translationModalDescription }}
</p>

<!-- File upload component -->
<div class="my-4">
  <nrc-file-uploader
    [acceptableMimeTypes]="['pptx', 'docx', 'xlsx', 'txt', 'html']"
    [isMultipleUploadEnabled]="false"
    (filesChangedEvent)="handleFileChange($event)"
    (fileSizeLimitExceededEvent)="fileSizeLimitExceededEvent.emit($event)"
  />
</div>

<!-- Display selected file info if available -->
@if (selectedFile()) {
  <div class="my-2">
    <nrc-media-preview
      [mimetype]="fileMimetype()"
      [source]="selectedFile()!.name"
    />
  </div>
}

<form [formGroup]="fileTranslateFormGroup" class="flex flex-col gap-4">
  <div class="relative flex flex-row w-full gap-4 justify-evenly" #overflowParentElementLanguageSelector>
    <!-- Source language selector -->
    <nrc-input-language-selector
      class="w-1/2 h-full min-h-12"
      [options]="sourceLanguageCodes"
      [formControl]="fileTranslateFormGroup.controls['from'] | formControl"
      [type]="inputLanguageSelectorComponentType.LABELED"
      [label]="'Source Language'"
      (languageChanged)="updateFilteredTargetLanguages()"
    />

    <nrc-input-language-selector
      class="w-1/2 h-full min-h-12"
      [options]="targetLanguageCodes"
      [formControl]="fileTranslateFormGroup.controls['to'] | formControl"
      [placeholder]="'Select a language'"
      [type]="inputLanguageSelectorComponentType.LABELED"
      [label]="'Target Language'"
      (languageChanged)="updateFilteredTargetLanguages()"
    />
  </div>

  <!-- Export to PDF option -->
  <div class="py-4">
    <nrc-input-checkbox
      [formControl]="fileTranslateFormGroup.controls['exportToPdf'] | formControl"
      [id]="'export-to-pdf'"
      [label]="'Export and save translated files as PDF'"
    />
  </div>
</form>

<hr class="w-full h-[2px] mt-3 bg-[#2d2d2d] border-none">

<div class="flex flex-row justify-between w-full mt-3 mb-1">
  <nrc-button
    [label]="'Cancel'"
    [buttonType]="buttonType.DEFAULT"
    [role]="actionRole.SECONDARY"
    [fontWeight]="'bold'"
    (clickEvent)="closeEvent.emit()"
  />

  <nrc-button
    [label]="'Translate'"
    [buttonType]="buttonType.DEFAULT"
    [role]="actionRole.PRIMARY"
    [fontWeight]="'bold'"
    [disabled]="!isTranslateEnabled()"
    (clickEvent)="handleTranslateFile()"
  />
</div>
